// Manual capture helpers wired at user-visible failure boundaries.
// Every helper attaches only safe tags (validated ids, workflow name).

import * as Sentry from "@sentry/react";
import { sentryEnabled } from "./instrument";

const SAFE_TAG_KEYS = new Set([
  "user_id",
  "workspace_id",
  "project_id",
  "route",
  "provider",
  "workflow",
]);

function report(workflow, error, context = {}) {
  if (!sentryEnabled) {
    // Local/preview without a DSN: still log to console for developer feedback.
    // eslint-disable-next-line no-console
    console.warn(`[sentry-off] ${workflow}`, error, context);
    return null;
  }
  return Sentry.withScope((scope) => {
    scope.setTag("workflow", workflow);
    for (const [key, value] of Object.entries(context)) {
      if (value == null) continue;
      if (SAFE_TAG_KEYS.has(key)) scope.setTag(key, String(value));
    }
    const err = error instanceof Error ? error : new Error(String(error));
    return Sentry.captureException(err);
  });
}

export const reportStripeCheckoutFailure = (err, ids = {}) =>
  report("stripe_checkout", err, { provider: "stripe", ...ids });

export const reportPdfFailure = (err, ids = {}) =>
  report("pdf_report", err, ids);

export const reportAutomationFailure = (err, ids = {}) =>
  report("automation_workflow", err, ids);

export const reportAuthFailure = (err, ids = {}) =>
  report("auth", err, ids);

export const reportCriticalApiFailure = (err, ids = {}) =>
  report("critical_api", err, ids);

// Fire a test event that lands in the Sentry frontend project. Returns the
// Sentry event_id — the admin panel posts it back to /api/admin/sentry/verify-frontend
// so the Integrations panel only flips to "connected" after both sides check in.
export function fireFrontendSentryTest() {
  if (!sentryEnabled) return null;
  const eventId = Sentry.captureMessage(
    "TrendRise AI · Sentry frontend integration test",
    "error"
  );
  try {
    Sentry.flush(2000);
  } catch (_e) {
    /* best-effort */
  }
  return eventId;
}
